export default status => {
  if (status === 'ACTIVE') {
    return '#ffe0b1';
  } if (status === 'PAID') {
    return '#ececff';
  } if (status === 'EXPIRED') {
    return '#e2e2e2';
  } return '#e2e2e2';
};
